import React from 'react';

interface RadioButtonProps {
  className?: string;
  active: boolean;
  name?: string;
  onToggle: Function;
}

const RadioButton = ({ active, onToggle, name, className = '' }: RadioButtonProps) => {
  const handleClick = () => {
    onToggle?.();
  };

  return <input name={name} type="radio" className={`${className}`} checked={active} onChange={handleClick} />;
};

export default RadioButton;
